import {createContext} from 'react';
import {defaultContext} from './model';

export const AdvancedDeliveryContext = createContext(defaultContext);
